import * as React from "react";

const SvgIcnSupportability = (props: React.SVGProps<SVGSVGElement>) => (
    <svg width="1em" height="1em" viewBox="0 0 24 24" {...props}>
        <g fill="none" fillRule="evenodd">
            <path
                fill="#FFF"
                fillRule="nonzero"
                d="M4 4.01v3.463a.5.5 0 11-1 0V3.51a.5.5 0 01.5-.5h3.959a.5.5 0 010 1H4z"
            />
            <path
                stroke="#FFF"
                d="M10.576 9.905a2 2 0 112.848 0c.734.799 1.197 2.182 1.197 3.595 0 2.173-1.107 4-2.621 4s-2.621-1.827-2.621-4c0-1.413.463-2.796 1.197-3.595z"
            />
            <path
                fill="#FFF"
                fillRule="nonzero"
                d="M9.051 13.5a.5.5 0 100-1h-2.9a.5.5 0 100 1h2.9zm8.256 0a.5.5 0 000-1H14.52a.5.5 0 100 1h2.786zM10.13 10a.5.5 0 110 1H7.974a.5.5 0 01-.435-.253l-.853-1.5a.5.5 0 01.87-.494L8.264 10h1.865zm3.77 0a.5.5 0 000 1h2.156a.5.5 0 00.434-.253l.853-1.5a.5.5 0 00-.869-.494L15.764 10H13.9zm-6.05 7.786a.5.5 0 11-.781-.625l1.575-1.966a.5.5 0 01.384-.188L9.65 15a.5.5 0 11.012 1l-.386.004-1.427 1.782zm8.254-.008a.5.5 0 10.792-.61l-1.514-1.966a.5.5 0 00-.39-.195L14.359 15a.5.5 0 00-.011 1l.39.004 1.366 1.774zM19.959 4.01v3.463a.5.5 0 101 0V3.51a.5.5 0 00-.5-.5H16.5a.5.5 0 100 1h3.459zM4 19.973V16.51a.5.5 0 10-1 0v3.963a.5.5 0 00.5.5h3.959a.5.5 0 000-1H4zm15.959-3.463a.5.5 0 111 0v3.963a.5.5 0 01-.5.5H16.5a.5.5 0 010-1h3.459V16.51z"
            />
        </g>
    </svg>
);

export default SvgIcnSupportability;
